module.exports = require("moment");


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 239
// module chunks = 0